export const data = [




{
    "Date":"6-11",
    "Event":"Mass for the Military 6pm SSPP",
},
{
    "Date":"6-11",
    "Event":"Council Rosary 7pm",
},
{
    "Date":"6-11",
    "Event":"Council Meeting 7:30pm",
},
{
    "Date":"6-14",
    "Event":"Donut Sunday at St. Mary's 6:30am",
},
{
    "Date":"6-17",
    "Event":"Blood Drive at St. Mary's Parish Center 4-7pm",
},

{
    "Date":"7-9",
    "Event":"Mass for the Military 6pm SSPP",
},
{
    "Date":"7-9",
    "Event":"Council Rosary at 7pm",
},
{
    "Date":"7-9",
    "Event":"Council Meeting at 7:30pm",
},
{
    "Date":"7-19",
    "Event":"Golf Tournament at Woodlands Golf Course 11:30am",
},
{
    "Date":"8-13",
    "Event":"Mass for the Military 6pm SSPP",
},
{
    "Date":"8-13",
    "Event":"Council Rosary at 7pm ",
},
{
    "Date":"8-13",
    "Event":"Council Meeting at 7:30pm",
},
{
    "Date":"9-10",
    "Event":"Mass for the Military 6pm SSPP",
},
{
    "Date":"9-10",
    "Event":"Council Rosary at 7pm ",
},
{
    "Date":"9-10",
    "Event":"Council Meeting at 7:30pm",
},
{
    "Date":"9-16",
    "Event":"ID Drive at Schnucks Godfrey",
},
{
    "Date":"9-17",
    "Event":"ID Drive at Schnucks Godfrey",
},
{
    "Date":"9-18",
    "Event":"ID Drive at Schnucks Godfrey",
},
{
    "Date":"9-19",
    "Event":"ID Drive in the Streets",
},
{
    "Date":"9-20",
    "Event":"ID Drive in the Streets",
},



];